import enUsPhonemeTokenMap from './en_us.json';
import { EN_US_PHONEME_ORDER } from './en_us';

const PHONEME_TOKEN_MAPS = {
  en_us: enUsPhonemeTokenMap,
};

const PHONEME_SORT_ORDERS = {
  en_us: EN_US_PHONEME_ORDER,
};

const DEFAULT_LANGUAGE = 'en_us';
const DEFAULT_PHONEMES = ['t', 'd', 's', 'z'];

export const getPhonemeOptionsByLanguage = (language) => {
  const normalizedLanguage = String(language || '').trim().toLowerCase() || DEFAULT_LANGUAGE;
  const tokenMap = PHONEME_TOKEN_MAPS[normalizedLanguage] || PHONEME_TOKEN_MAPS[DEFAULT_LANGUAGE] || {};
  const sortOrder = PHONEME_SORT_ORDERS[normalizedLanguage] || PHONEME_SORT_ORDERS[DEFAULT_LANGUAGE] || [];
  const orderMap = new Map(sortOrder.map((token, index) => [token, index]));

  return Object.entries(tokenMap)
    .filter(([token]) => token && !token.startsWith('<'))
    .sort((a, b) => {
      const orderA = orderMap.has(a[0]) ? orderMap.get(a[0]) : Number.POSITIVE_INFINITY;
      const orderB = orderMap.has(b[0]) ? orderMap.get(b[0]) : Number.POSITIVE_INFINITY;
      if (orderA !== orderB) return orderA - orderB;
      return Number(a[1]) - Number(b[1]);
    })
    .map(([token]) => token);
};

export const getDefaultSelectedPhonemes = (language) => {
  const options = getPhonemeOptionsByLanguage(language);
  const defaults = DEFAULT_PHONEMES.filter((token) => options.includes(token));
  if (defaults.length > 0) return defaults;
  return options.slice(0, 4);
};
